<eda-dialog2 [display]="display" [header]="title" width="60vw" height="80vh" [overflow]="'auto'"
  (apply)="saveMap()" (close)="closeDialog()" [disableApply]="!canConfirm"  
  (nextstep)="nextStep()" [showNextStep]="activeTab === 'step1'" [disableNextStep]="!canGoNext">

  <div content class="p-2 space-y-6">
    <!-- Tabs (2 pestañas: propiedades+columnas fusionadas, y mapas disponibles) -->
    <div class="grid w-full grid-cols-2 gap-3">
      <button
        [ngClass]="{'map-tab-active': activeTab === 'step1' || activeTab === 'step2', 'bg-gray-100': activeTab === 'available'}"
        class="px-3 py-2 font-semibold rounded-md transition-colors"
        (click)="setActiveTab('step1')">
        <span i18n="@@inputMapTables">Propiedades del mapa</span>
      </button>
      <button
        [ngClass]="{'map-tab-active': activeTab === 'available', 'bg-gray-100': activeTab !== 'available'}"
        class="px-3 py-2 font-semibold rounded-md transition-colors"
        (click)="setActiveTab('available')">
        <span i18n="@@availableMaps">Mapas disponibles</span>
      </button>
    </div>

    <!-- Tab Content -->
    <form [formGroup]="mapForm">
      <!-- Step 1: Map Properties -->
      <div [hidden]="activeTab !== 'step1'" class="space-y-6">
        <div class="bg-white rounded-lg border p-4">
          <div class="mb-3">
            <h3 class="text-lg font-medium flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map">
                <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
                <line x1="9" x2="9" y1="3" y2="18"/>
                <line x1="15" x2="15" y1="6" y2="21"/>
              </svg>
              <span i18n="@@inputMapTables">Propiedades del mapa</span>
            </h3>
            <p class=" text-gray-500" i18n="@@mapDescription">Configurar las propiedades básicas de la visualización de su mapa</p>
          </div>

          <div class="space-y-6">
            <!-- GeoJSON Upload -->
            <div class="space-y-2">
              <label for="geojson" class="block  font-medium" i18n="@@inputMapURL">Subir archivo GeoJson (JSON)</label>
              <div class="flex items-center gap-2 w-full">
                <app-uploadFile #fileUploader class="w-full" (onFileSaved)="fileLoaded()"></app-uploadFile>
              </div>
            </div>

            <hr class="border-gray-200">

            <!-- Data Model Field -->
            <div class="space-y-2">
              <label for="datamodel" class="block  font-medium flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database">
                  <ellipse cx="12" cy="5" rx="9" ry="3"/>
                  <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
                  <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
                </svg>
                <span i18n="@@inputMapField">Campo a usar para vincular el modelo con el mapa</span>
              </label>
              <p-dropdown class="map-dropdown"
                inputId="datamodel"
                formControlName="dataModelField"
                [options]="fields" optionLabel="label" optionValue="value"
                i18n-placeholder="@@selectField" placeholder="Selecciona un campo"
                [style]="{'width':'100%'}" appendTo="body">
              </p-dropdown>
            </div>

            <!-- Map Name -->
            <div class="space-y-2">
              <label for="map-name" class="block  font-medium" i18n="@@inputMapName">Nombre del mapa</label>
              <input
                type="text"
                id="map-name"
                formControlName="mapName"
                placeholder="Enter a descriptive name for your map"
                class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--corporate-primary)] focus:border-[var(--corporate-primary)]">
            </div>

            <!-- Map Center -->
            <div class="space-y-2">
              <label for="latitude" class="block  font-medium flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span i18n="@@inputx">Centro del mapa (Latitud, Longitud)</span>
              </label>
              <p class=" text-gray-500" i18n="@@inputxDescription">Si desconoces las coordenadas del centro las calcularemos automáticamente</p>
              <div class="grid grid-cols-2 gap-2">
                <input
                  type="text"
                  id="latitude"
                  formControlName="latitude"
                  placeholder="Latitude (e.g. 40.7128)"
                  class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--corporate-primary)] focus:border-[var(--corporate-primary)]"
                >
                <input
                  type="text"
                  id="longitude"
                  formControlName="longitude"
                  placeholder="Longitude (e.g. -74.0060)"
                  class="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--corporate-primary)] focus:border-[var(--corporate-primary)]"
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Link Columns -->
      <div [hidden]="activeTab !== 'step2'" class="space-y-6">
        <div class="bg-white rounded-lg border p-4">
          <div class="mb-3">
            <h3 class="text-lg font-medium flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-columns">
                <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                <line x1="12" x2="12" y1="3" y2="21"/>
              </svg>
              <span i18n="@@inputMapColumnsText">Vincular columnas al mapa</span>
            </h3>
            <p class=" text-gray-500" i18n="@@linkMapColumnsDescription">Conecte sus columnas de datos a la visualización geográfica</p>
          </div>

          <div class="space-y-6">
            <!-- Table Selection -->
            <div class="space-y-2">
              <label for="table" class="block  font-medium flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-table-2">
                  <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>
                </svg>
                <span i18n="@@inputMapTables">Tablas</span>
              </label>
              <p-dropdown class="map-dropdown"
                inputId="table"
                formControlName="selectedTable"
                [options]="tables" optionLabel="label" optionValue="value"
                i18n-placeholder="@@selectTable" placeholder="Selecciona una tabla"
                [style]="{'width':'100%'}" appendTo="body">
              </p-dropdown>
            </div>

            <!-- Column Selection -->
            <div class="space-y-2">
              <label for="column" class="block  font-medium">
                <span i18n="@@inputMapColumns">Columnas</span>
              </label>
              <p-dropdown class="map-dropdown"
                inputId="column"
                formControlName="selectedColumn"
                [options]="columns" optionLabel="label" optionValue="label"
                i18n-placeholder="@@selectColumn" placeholder="Selecciona una columna"
                [style]="{'width':'100%'}" appendTo="body">
              </p-dropdown>
            </div>

            <!-- Link Button -->
            <div class="pt-4">
              <button
                (click)="pushItem()"
                class="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md  font-medium">
                <span i18n="@@linkColumn">Vincular columna</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Linked Columns List -->
        @if(linkedColumns.length > 0){
          <div class="bg-white rounded-lg border p-4">
            <div class="space-y-2">
              @for(link of linkedColumns; track $index){
                <div class="flex items-center justify-between p-3 border rounded-md bg-gray-50">
                  <div class="flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link text-red-500">
                      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                    </svg>
                    <span class="text-sm text-gray-700">{{ link.table }} : {{ link.col.column_name }}</span>
                  </div>
                  <button
                    type="button"
                    (click)="deleteLink(link)"
                    class="p-1 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-md">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
                      <path d="M18 6 6 18"/>
                      <path d="m6 6 12 12"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Available Maps Tab -->
      <div [hidden]="activeTab !== 'available'" class="space-y-6">
        <div class="bg-white rounded-lg border p-4">
          @if(serverMaps.length > 0){
            <div class="mb-3">
              <h3 class="text-lg font-medium flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
                <span i18n="@@availableMaps" i18n="@@mapsAvailable">Mapas disponibles</span>
              </h3>
              <p class=" text-gray-500" i18n="@@mapsAvailableDescription">Mapas que están actualmente configurados y disponibles para su uso</p>
            </div>
          }

          @for (map of serverMaps; track map) {
            <div class="flex flex-col gap-2">
              <div class="flex items-center justify-between p-3 border rounded-md bg-slate-50">
                <div class="flex items-center gap-2">
                  <span class="px-2 py-1 bg-white border rounded-md">{{ map.name }} - {{map.field}}</span>
                  <span> [
                      @for (el of map.linkedColumns; track el) {
                        {{el.table}} - {{el.col.display_name.default}},
                      }
                    ]
                 </span>
                </div>
                <button
                  (click)="removeMap(map)"
                  class="p-1 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
                    <path d="M18 6 6 18"/>
                    <path d="m6 6 12 12"/>
                  </svg>
                </button>
              </div>
            </div>
          }

          @if(serverMaps.length === 0){
            <div class="flex flex-col items-center justify-center py-8 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe text-gray-300 mb-2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              <p class="text-gray-500" i18n="@@noMapsAvailable">No hay mapas disponibles</p>
              <p class=" text-gray-400 mt-1" i18n="@@noMapsAvailableDescription">Configurar un mapa en la pestaña Propiedades del mapa</p>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</eda-dialog2>


